var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraderWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37510",
    "data-name": "Group 37510",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3032",
    "data-name": "Rectangle 3032",
    width: 32,
    height: 32,
    rx: 8,
    fill: "#bdc3d0",
    opacity: 0.242
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trader-3",
    transform: "translate(3.133 3.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40662",
    "data-name": "Path 40662",
    d: "M18.961,15.589v3.247a.469.469,0,0,1-.469.469h-.879l.328-2.3A1.406,1.406,0,0,0,16.55,15.4H9.184A1.406,1.406,0,0,0,7.792,17l.329,2.3H7.243a.469.469,0,0,1-.469-.469V15.589a2.347,2.347,0,0,1,1.74-2.265l1.521-.405a3.59,3.59,0,0,0,5.667,0l1.521.405a2.347,2.347,0,0,1,1.74,2.265ZM20.73,8.755a.469.469,0,0,0-.663,0l-.45.45V5.336a.469.469,0,0,0-.938,0V9.2l-.45-.45a.469.469,0,0,0-.663.663l1.25,1.25a.469.469,0,0,0,.663,0l1.25-1.25a.469.469,0,0,0,0-.663ZM7.055,10.336V6.468l.45.45a.469.469,0,1,0,.663-.663L6.918,5a.469.469,0,0,0-.663,0L5,6.255a.469.469,0,1,0,.663.663l.45-.45v3.868a.469.469,0,0,0,.938,0Zm9.96,6.535L16.5,20.465a.469.469,0,0,1-.464.4H9.7a.469.469,0,0,1-.464-.4L8.72,16.871a.469.469,0,0,1,.464-.535h7.366a.469.469,0,0,1,.464.535Zm-3.678,1.34a.469.469,0,1,0-.469.469.469.469,0,0,0,.469-.469Zm-.469-4.844a2.656,2.656,0,0,0,2.656-2.656V9.18H10.211v1.531a2.656,2.656,0,0,0,2.656,2.656Zm3.75-7.231V5.711a.469.469,0,0,0-.469-.469H12.242a2.031,2.031,0,0,0-2.031,2.031v.969h5.313a2.569,2.569,0,0,0,1.094-2.106Z",
    fill: "#1a49a3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraderWithBg);
export default __webpack_public_path__ + "static/media/traderWithBg.ae14290c85c1d7e464af010538b3869c.svg";
export { ForwardRef as ReactComponent };